export default "__VITE_ASSET__C0sY6_6Z__"